import { Injectable } from '@angular/core';
import {HttpBackend, HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/index';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';

import { Configuration as config } from '../../main/configuration/main.config';

export interface MetaDataItem {
  name: string;
  id?: number;
}

@Injectable()
export class MetaDataService {

  private http: HttpClient;

  constructor(handler: HttpBackend) {
    // Creating new httpClient instance to avoid passing request through our http interceptor
    // to avoid adding Authorization header to S3.
    // https://github.com/angular/angular/issues/20203#issuecomment-368680437
    this.http = new HttpClient(handler);
  }

  getItems(name: string): Observable<string[]> {
    const url = `${config.metaDataURL}/${config.urls.meta_data.get}/${name}.json`;

    return this.http.get(url).pipe(map((res: MetaDataItem[]) => _.map(res, 'name')));
  }

  getCountries(): Observable<any> {
    const url = `${config.metaDataURL}/${config.urls.meta_data.get}/countries.json`;

    return this.http.get(url);
  }

  getCRCountries() {
    return this.http
      .get(`${config.metaDataURL}/${config.urls.meta_data.get}/crOffices.json`);
  }
}
